var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:(`min-height: ${_vm.height}px`)},[_c('v-row',{staticStyle:{"height":"90%"},attrs:{"no-gutters":""}},[(_vm.opts.series.length > 0)?_c('e-chart',{style:(`width: 100%; max-width: 100%; max-height: 100%; min-height:${_vm.height}px;height:${_vm.height}px`),attrs:{"option":_vm.opts,"autoresize":true}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }